import React, {useState} from "react";
import Form from "./form/Form";
import HeaderBar from "../user-page-components/header-bar/HeaderBar";
import { getCookie } from "../../utils/cookieUtils";

const UserPageComponents =() =>{
  const [replayCount, setReplayCount] = useState(0);
  const [batchId, setBatchId] = useState("");
  const username = getCookie("X-Spl-Username-Header");
  const handleBatchIdChange = (newBatchId) => {
    setBatchId(newBatchId);
  }
    
  return (
    <div>
      <HeaderBar onBatchIdChange={handleBatchIdChange}/>
      <div class="grid-container-main">
        {batchId && <Form replayCount={replayCount} batchId={batchId}></Form>}
      </div>
    </div>
  );
}

export default UserPageComponents;